import React from 'react'
import content from '../../../../docs/legal/privacy-policy.md?raw'
import { MarkdownDoc } from '../../components/MarkdownDoc'

export default function Privacy() {
  return (
    <div className="legal-page">
      <MarkdownDoc content={content} />
    </div>
  )
}
